/**
 * The program's dated trainings that apply to one applicant. `sessions` is
 * `trainingSessions` from GET /api/program/:type/requirements (already limited
 * to one term); a returning applicant gets "returning" and "all", a new one
 * gets "new" and "all".
 */
export const trainingSessionsFor = (sessions = [], isReturning) =>
    sessions.filter(
        ({ appliesTo }) =>
            appliesTo === 'all' ||
            appliesTo === (isReturning ? 'returning' : 'new')
    );

/**
 * One sentence for a confirmation, such as "New LAs also attend: Orientation,
 * Jan 12-13; Pedagogy seminar, Fridays 10:00-11:30 AM". Empty when nothing
 * applies, so the caller can leave the sentence out.
 */
export const trainingLine = (sessions, isReturning) => {
    const applicable = trainingSessionsFor(sessions, isReturning);
    if (!applicable.length) return '';
    const who = isReturning ? 'Returning LAs' : 'New LAs';
    return `${who} also attend: ${applicable
        .map(({ title, when }) => `${title}, ${when}`)
        .join('; ')}`;
};
